import { request } from './helpers/request'
import { GENERIC_PASSWORD_RESET_CONFIRMATION_CODE } from '../constants/error.codes'

export const submitPasswordResetConfirmation = (data) =>
  request({
    url: `/users/password/recover/${data.token}`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8',
    },
    data: new URLSearchParams(data).toString(),
  }).then((response) => {
    if (response.status === 204) {
      return Promise.resolve(response)
    } else if (response.status === 400) {
      return Promise.reject(new Error(response.data.code))
    } else {
      return Promise.reject(new Error(GENERIC_PASSWORD_RESET_CONFIRMATION_CODE))
    }
  })
